module.exports = __webpack_public_path__ + "static/media/eymLogo.67dff0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/eymLogo.png
// module id = 1422
// module chunks = 0